<button class="usa-button usa-button--accent-warm" (click)="generateFile()">{{ params.btnName }}</button>